// extracted by mini-css-extract-plugin
export default {"productInfo":"ProductInfo_productInfo__PFcgV","badgeList":"ProductInfo_badgeList__bpQB6","clamp":"ProductInfo_clamp__uwkOO","rank":"ProductInfo_rank__1pack"};